export enum DatabaseType {
    Legacy = 'legacy',
    Tablesdb = 'tablesdb',
    Documentsdb = 'documentsdb',
    Vectorsdb = 'vectorsdb',
}